<wl-invoice-summary #summary [invoice]="invoice" [isEditable]="false"></wl-invoice-summary>
<wl-invoice-adjustments-list
  [invoice]="invoice"
  [flatAdjustmentIds]="flatAdjustmentIds"
  [isLineItemAdjustments]="isLineItemAdjustments"
  [allRevenueItems]="allRevenueItems"
></wl-invoice-adjustments-list>
<div [hidden]="!addingNewAdjustment" [ngClass]="flatAdjustmentIds.length % 2 == 1 ? 'alt-row p-10 mb-10' : 'p-10 mb-10'">
  <div class="mct-flex mct-row mct-wrap mct-justify-between mct-items-stretch"  >
    <div class="mct-flex mct-col mct-gap-27"  >
      <div class="mct-flex mct-row mct-wrap mct-gap-7"  >
        <div class="mct-flex mct-col" >
          <label>{{ 'invoices.invoice-builder.adjustments-tab.adjustment-date' | translate | titlecase }}</label>
          <wl-date-selector ngDefaultControl name="adjustmentDate" [(ngModel)]="adjustmentHeader.AdjustmentDate"></wl-date-selector>
        </div>
        <div class="mct-flex mct-col" >
          <label>{{ 'invoices.invoice-builder.adjustments-tab.apply-date' | translate | titlecase }}</label>
          <wl-date-selector ngDefaultControl name="applyDate" [(ngModel)]="adjustmentHeader.ApplyDate"></wl-date-selector>
        </div>
      </div>
      <div>
        <p-messages *ngIf="(summary.updatedBalance | async) < 0" severity="warn">
          <ng-template pTemplate>
            <span>{{ 'invoices.invoice-builder.adjustments-tab.overpayment-warning' | translate }}</span>
          </ng-template>
        </p-messages>
        <label>{{ 'invoices.invoice-builder.adjustments-tab.adjustment-total' | translate | titlecase }}</label>
        <div class="p-inputgroup">
          <button pButton type="button" class="atlas-input-addon" (click)="flipAdjustmentSign()">{{ adjustmentSign }}</button>
          <span class="atlas-input-addon">$</span>
          <input
            [(ngModel)]="adjustmentHeader.AdjustmentAmount"
            (change)="formatAdjustmentAmount()"
            type="number"
            [disabled]="disallowPartialPaymentAdjustment"
          />
        </div>
        <div class="warning-box mt-10 t-ac" [hidden]="!disallowPartialPaymentAdjustment">
          {{ 'invoices.invoice-builder.adjustments-tab.partial-cc-void-warning' | translate }}
        </div>
      </div>
    </div>
    <div class="mct-flex mct-col mct-gap-27 invoice-adj-half-gt-sm"   >
      <div>
        <label>{{ 'invoices.invoice-builder.adjustments-tab.adjustment-type' | translate | titlecase }}</label>
        <p-select
          [(ngModel)]="selectedAdjustmentType"
          placeholder="{{ 'invoices.invoice-builder.select-label' | translate }}"
          [options]="adjustmentTypes"
          optionLabel="AdjustmentType"
          [style]="{ width: '100%' }"
        ></p-select>
      </div>
      <div>
        <label style="width: 100%">{{ 'invoices.invoice-builder.adjustments-tab.adjustment-descr' | translate | titlecase }}</label>
        <input type="text" [(ngModel)]="adjustmentHeader.Descr" class="form-input" style="width: 100%" />
      </div>
    </div>
  </div>
  <hr style="color: #ececec" />
  <ng-container *ngIf="isLineItemAdjustments">
    <div class="adjustment-row-container mv-10 adjustment-labels">
      <span>{{ 'invoices.invoice-builder.adjustments-tab.adjustment-amount' | translate | titlecase }}</span>
      <span>{{ 'invoices.invoice-builder.adjustments-tab.line-item-descr' | translate | titlecase }}</span>
      <span>{{ 'invoices.invoice-builder.adjustments-tab.line-item-amount' | translate | titlecase }}</span>
      <span>{{ 'invoices.invoice-builder.adjustments-tab.line-item-id' | translate }}</span>
    </div>
    <ng-container *ngFor="let lineItem of invoice.LineItems">
      <div class="adjustment-row-container mv-10">
        <div class="p-inputgroup">
          <button pButton type="button" class="atlas-input-addon" (click)="flipAdjustmentSign()">{{ adjustmentSign }}</button>
          <span class="atlas-input-addon">$</span>
          <input
            [(ngModel)]="lineItem.AdjustmentAmountToApply"
            type="number"
            (input)="revenueObservationService.invoiceAmountChanged(invoice.InvoiceHeader.InvoiceNum)"
          />
        </div>
        <span>
          {{ !lineItem.Descr && lineItem?.ItemNum && allRevenueItems?.length ? getItemDescription(lineItem?.ItemNum) : lineItem.Descr }}
        </span>
        <span> {{ lineItem.Amount | currency }} </span>
        <span> {{ lineItem.LineItemId }} </span>
      </div>
      <div *ngFor="let taxLineItem of lineItem.TaxLineItems" class="adjustment-row-container mv-10">
        <div class="p-inputgroup">
          <button pButton type="button" class="atlas-input-addon" (click)="flipAdjustmentSign()">{{ adjustmentSign }}</button>
          <span class="atlas-input-addon">$</span>
          <input
            [(ngModel)]="taxLineItem.AdjustmentAmountToApply"
            type="number"
            (input)="revenueObservationService.invoiceAmountChanged(invoice.InvoiceHeader.InvoiceNum)"
          />
        </div>
        <span> {{ taxLineItem.Descr }} </span>
      </div>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="!isLineItemAdjustments">
    <div class="adjustment-row-container mv-10 adjustment-labels">
      <span>{{ 'invoices.invoice-builder.adjustments-tab.adjustment-amount' | translate | titlecase }}</span>
      <span>{{ 'invoices.invoice-builder.adjustments-tab.description' | translate | titlecase }}</span>
      <span>{{ 'invoices.invoice-builder.adjustments-tab.payment-id' | translate }}</span>
    </div>
    <ng-container *ngFor="let lineItem of invoice.LineItems">
      <div *ngFor="let payment of lineItem.Payments" class="adjustment-row-container mv-10">
        <div class="p-inputgroup">
          <button pButton type="button" class="atlas-input-addon" (click)="flipAdjustmentSign()">{{ adjustmentSign }}</button>
          <span class="atlas-input-addon">$</span>
          <input
            [(ngModel)]="payment.AdjustmentAmountToApply"
            type="number"
            [disabled]="disallowPartialPaymentAdjustment"
            (input)="revenueObservationService.invoiceAmountChanged(invoice.InvoiceHeader.InvoiceNum)"
          />
        </div>
        <span> {{ payment.PaymentType }} </span>
        <span> {{ payment.PaymentID }}</span>
      </div>
    </ng-container>
  </ng-container>
</div>
<div *ngIf="!addingNewAdjustment" class="apply-adjustment-button mct-flex mct-row mct-justify-start mct-items-stretch"  >
  <button pButton type="button" class="atlas-btn atlas-btn-default" (click)="addAdjustment()">
    <i class="pi pi-plus"></i>
    {{
      isLineItemAdjustments
        ? ('invoices.invoice-builder.adjustments-tab.add-line-item-adjustment' | translate | uppercase)
        : ('invoices.invoice-builder.adjustments-tab.add-payment-adjustment' | translate | uppercase)
    }}
  </button>
</div>
<div *ngIf="addingNewAdjustment" class="apply-adjustment-button mct-flex mct-row mct-justify-start mct-items-stretch"  >
  <button pButton type="button" class="btn btn-danger" (click)="cancelAdjustment()">
    <i class="pi pi-times"></i>
    {{ 'invoices.invoice-builder.adjustments-tab.cancel-adjustment' | translate | uppercase }}
  </button>
</div>
